<template>
  <va-dropdown
    class="profile-dropdown"
    v-model="isShown"
    boundary-body
    position="bottom"
    :offset="[0, 13]"
  >
    <template #anchor>
      <span class="profile-dropdown__anchor">
        <slot />
        <va-icon
          class="px-2"
          :name="isShown ? 'angle_up' : 'angle_down'"
          :color="theme.primary"
        />
      </span>
    </template>
    <va-dropdown-content >
      <va-list-item >
          <va-chip style="width: 100%;" flat icon="user" class="text-regular" >
            {{displanName}}
          </va-chip>
      </va-list-item>
   <va-divider />
      <va-list-item>
          <va-chip style="width: 100%;" flat icon="clear" @click="Logout" color="danger" class="text-regular">
            {{ $t('button.logout') }}
          </va-chip>
      </va-list-item>
    </va-dropdown-content>
  </va-dropdown>
</template>

<script>
import { useGlobalConfig } from "vuestic-ui";
import AuthenService from "@/services/authen-service/AuthenService";
import { defineComponent, computed } from "vue";
export default defineComponent({
  name: "profile-section",
  data() {
    return {
      isShown: false,
      displanName:''
    };
  },
  props: {
    options: {
      type: Array,
      default: () => [
        {
          name: "profile",
          redirectTo: ""
        },
        {
          name: "logout",
          redirectTo: "login"
        }
      ]
    }
  },
  methods: {
    Logout() {
      this.$store.commit('logOut');
      new AuthenService().logoutOauth2(process.env.VUE_APP_URL_MSP_FRONTEND_LOGIN);
    },
    GetDisplayName(){
      let userInfo = this.$store.state.userInfo;
      this.displanName = userInfo.firstName + ' ' + userInfo.lastName

    }
  },
  computed: {
    theme() {
      return useGlobalConfig().getGlobalConfig();
    }
  },
  mounted() {
    this.GetDisplayName();  
  },
});
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  .va-dropdown-popper__anchor {
    display: flex;
    justify-content: flex-end;
  }

  &__content {
    width: 8rem;
  }

  &__item {
    display: block;
    color: var(--va-gray);

    &:hover,
    &:active {
      color: var(--va-primary);
    }
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
